/** @format */

export enum ShuffleOption {
	Shuffle = "shuffle",
	Select = "select",
}
